module.exports = __webpack_public_path__ + "static/media/lc_dec.21f1181e.png";